import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    Pager
} from 'devextreme-react/data-grid';
import Request from "../../components/Request/Request";
import CustomStore from 'devextreme/data/custom_store';
import './Gosterge.scss';
import { Button, Popup } from 'devextreme-react';
import GostergeDetay from './GostergeDetay';
import { custom } from 'devextreme/ui/dialog';
import * as AppActions from '../../actions/AppActions';


const Gosterge = () => {

    const dispatch = useDispatch();

    const listeBasligi = "Gösterge Tanım";
    const [store, setStore] = useState(null);
    const [detayData, setDetayData] = useState({ popupState: false, data: [] });

    let dataGrid = null;

    useEffect(() => {
        yenile();
    }, []);

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            load: function () {
                const request = new Request("/emeklilik-app/api/gosterge-tanim/getList", "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    const yenile = () => {
        setStore(getStore());
    }
    function hideDetayDataPopup() {
        setDetayData({ popupState: false, data: {} })
        yenile();
    }
    function editDetay(data) {
        setDetayData({ popupState: true, data: data })
    }
    function deleteDetay(data) {
        let myDialog = custom({
            title: "Silme Uyarı",
            messageHtml: "<b>Seçili kaydı silmek istiyor musunuz?</b>",
            buttons: [{
                text: "Evet",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            }, {
                text: "Hayır",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText === 'Evet') {
                dispatch(AppActions.setLoading(true, "Kayıtlar siliniyor.."));
                const request = new Request("/emeklilik-app/api/gosterge-tanim/delete/" + data.id, "DELETE");
                request.run()
                    .then(response => {
                        dispatch(AppActions.setLoading(false, ""));
                        if (response.statusText == 'OK') {
                            yenile();
                        }
                    });
            }

        });



    }

    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: () => { return true },
            options: {
                icon: 'add',
                onClick: () => {
                    setDetayData({ popupState: true, data: null })
                }
            }
        });
    }
    //test
    return (
        <div>
            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    {/* <Button icon="plus" width={150} text="Yeni Kayıt" type={'success'} style={{ fontSize: "15px" }}></Button> */}
                </div>
            </div>

            <DataGrid
                className="gostergeGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                onToolbarPreparing={onToolbarPreparingDetay}
            //selection={{ mode: 'single', deferred: true }} 
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging defaultPageSize={20} />
                <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        {
                            hint: 'Düzenle', icon: 'edit',
                            onClick: (e) => { editDetay(e.row.data); }
                        },
                        {
                            hint: 'Sil', icon: 'remove',
                            onClick: (e) => { deleteDetay(e.row.data); }
                        }
                    ]}
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'yil'} width={50} caption={'Yıl'} dataType="number"  defaultSortOrder="asc"/>
                <Column dataField={'altKazanc'} width={150} caption={'Alt Kazanç'} dataType="number" />
                <Column dataField={'ustKazanc'} width={150} caption={'Üst Kazanç'} dataType="number" />
                <Column dataField={'gostergeDeger'} width={150} caption={'Gösterge'} dataType="number" />
                <Column dataField={'aboDeger'} width={150} caption={'Abo'} dataType="number" />
                <Column dataField={'derece'} width={150} caption={'Derece'} dataType="number" />
                <Column dataField={'kademe'} width={150} caption={'Kademe'} dataType="number" />
                <Column dataField={'gostergeTipi'} width={150} caption={'Gösterge Tipi'} dataType="string" />
                <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} />
            </DataGrid>

            <Popup
                visible={detayData.popupState}
                onHiding={hideDetayDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Detay Bilgi"
                width={350}
                height={430}
            >
                <div>
                    {detayData.popupState ? <GostergeDetay data={detayData.data} hide={hideDetayDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideDetayDataPopup}
                    />
                </div>
            </Popup>

        </div>
    );


}

export default Gosterge;
